export const permissionsRolesFull = ["roles-full", "everything-full"];
